import { MerchantsApi } from '../../api';
import axios from '../axios';

const merchantsApi = new MerchantsApi(undefined, undefined, axios);

export default merchantsApi;
